import React, { forwardRef, useState } from "react";

interface PasswordInputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  showOrHidePassword?: boolean;
}

export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ showOrHidePassword = true, ...props }, ref) => {
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);

    const togglePasswordVisibility = () => {
      setIsPasswordVisible((prev) => !prev);
    };

    return (
      <div className="input" data-toggle-password="true">
        <input
          ref={ref}
          type={isPasswordVisible ? "text" : "password"}
          {...props}
        />
        {showOrHidePassword && (
          <button
            className="btn btn-icon"
            type="button"
            onClick={togglePasswordVisibility}
          >
            {isPasswordVisible ? (
              <i className="ki-solid ki-eye-slash text-gray-500"></i>
            ) : (
              <i className="ki-solid ki-eye text-gray-500"></i>
            )}
          </button>
        )}
      </div>
    );
  },
);
